import { TabPanel } from 'common/components/TabPanel/TabPanel'
import { useLazyFetchLeaseDocumentsQuery } from 'features/Home/Book/state/api/bookApi'
import { BillingHistory } from 'features/Profile/features/BillingHistory/BillingHistory'
import { type FC, memo, useEffect, useMemo } from 'react'
import { Navigate, useParams } from 'react-router'
import { PATH_SEGMENT } from 'routes/pathSegments'
import { generateRouter } from 'routes/routes.utils'
import type { DocumentsProps } from './documents.types'
import { DocumentsTable } from './DocumentsTable/DocumentsTable'

export const Documents: FC<DocumentsProps> = memo(() => {
  const { bookingId, siteId } = useParams()

  const [fetchDocuments, { data, isLoading }] = useLazyFetchLeaseDocumentsQuery()

  const tabs = useMemo(
    () => [
      {
        path: PATH_SEGMENT.CONTRACTS,
        title: 'Contracts',
      },
      {
        path: PATH_SEGMENT.BILLING,
        title: 'Billing',
      },
    ],
    [],
  )

  const routesConfig = useMemo(
    () => ({
      [PATH_SEGMENT.CONTRACTS]: <DocumentsTable data={data} isLoading={isLoading} />,
      [PATH_SEGMENT.BILLING]: <BillingHistory bookingId={bookingId} />,
      [PATH_SEGMENT.ROOT]: <Navigate to={PATH_SEGMENT.CONTRACTS} replace />,
    }),
    [data, isLoading, bookingId],
  )

  useEffect(() => {
    if (!bookingId || !siteId) {
      return
    }

    fetchDocuments({ bookingId, siteId })
  }, [bookingId, siteId])

  return (
    <>
      <TabPanel tabs={tabs} />
      {generateRouter(routesConfig)}
    </>
  )
})
